import { Button } from "./Button";

type CollectionQuantityControlsProps = {
  quantity: number;
  disabled?: boolean;
  compact?: boolean;
  quiet?: boolean;
  micro?: boolean;
  addLabel?: string;
  onAdd: () => void;
  onIncrement: () => void;
  onDecrement: () => void;
  onRemove: () => void;
};

function DeleteGlyph() {
  return (
    <svg className="hw-qty__trash" viewBox="0 0 20 20" aria-hidden="true" focusable="false">
      <path
        fill="currentColor"
        d="M7.4 2h5.2l.6 1.6H16v1.6H4V3.6h2.8L7.4 2zm-1.6 4.8h8.4l-.7 10.1A1.6 1.6 0 0 1 12 18.4H8A1.6 1.6 0 0 1 6.5 16.9L5.8 6.8z"
      />
    </svg>
  );
}

export function CollectionQuantityControls({
  quantity,
  disabled = false,
  compact = false,
  quiet = false,
  micro = false,
  addLabel = "В коллекцию",
  onAdd,
  onIncrement,
  onDecrement,
  onRemove,
}: CollectionQuantityControlsProps) {
  if (quantity <= 0) {
    return (
      <Button
        type="button"
        variant={compact ? "ghost" : quiet ? "ghost" : "primary"}
        onClick={onAdd}
        disabled={disabled}
        className={
          compact
            ? [
                "hw-qty__add",
                "hw-qty__add--wide",
                quiet ? "hw-qty__add--quiet" : "",
                micro ? "hw-qty__add--micro" : "",
              ]
                .filter(Boolean)
                .join(" ")
            : undefined
        }
        aria-label="Добавить в коллекцию"
      >
        {compact ? (
          <>
            <span aria-hidden="true">+</span>
            <span>Добавить</span>
          </>
        ) : (
          addLabel
        )}
      </Button>
    );
  }

  const qtyClass = [
    compact ? "hw-qty hw-qty--compact" : "hw-qty",
    micro ? "hw-qty--micro" : "",
  ]
    .filter(Boolean)
    .join(" ");

  // Density-3: − N + only; decrement at 1 removes via existing quantity=0 semantics.
  const showRemove = !micro;
  const decrementDisabled = disabled || (!micro && quantity <= 1);

  return (
    <div className={qtyClass}>
      <Button
        type="button"
        variant="ghost"
        className="hw-qty__btn"
        onClick={onDecrement}
        disabled={decrementDisabled}
        aria-label="Уменьшить количество"
      >
        −
      </Button>
      <span className="hw-qty__value" aria-live="polite">
        {quantity}
      </span>
      <Button
        type="button"
        variant="ghost"
        className="hw-qty__btn"
        onClick={onIncrement}
        disabled={disabled}
        aria-label="Увеличить количество"
      >
        +
      </Button>
      {showRemove ? (
        <Button
          type="button"
          variant="ghost"
          className={
            compact ? "hw-qty__remove hw-qty__remove--icon" : undefined
          }
          onClick={onRemove}
          disabled={disabled}
          aria-label="Удалить из коллекции"
        >
          {compact ? <DeleteGlyph /> : "Удалить"}
        </Button>
      ) : null}
    </div>
  );
}
